import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { TRANSLATION } from '../utils'
import { CourseProgressStatus } from '../types'

import InProgressEmptyIcon from '../assets/in-progress-empty-icon.svg'
import CompletedEmptyIcon from '../assets/completed-empty-icon.svg'
import SavedEmptyIcon from '../assets/saved-empty-icon.svg'
import * as Styles from './styles'

type Props = {
  state: CourseProgressStatus
}

export const Empty = (props: Props) => {
  const { i18n } = useI18n()
  const { isTablet } = useMediaQueries()
  const KEY = `${TRANSLATION}.progress.empty`

  const states = {
    in_progress: {
      icon: InProgressEmptyIcon,
      title: i18n.t(`${KEY}.in_progress`),
    },
    completed: {
      icon: CompletedEmptyIcon,
      title: i18n.t(`${KEY}.completed`),
    },
    saved: {
      icon: SavedEmptyIcon,
      title: i18n.t(`${KEY}.saved`),
    },
  }

  return (
    <Styles.EmptyStateContainer data-testid="empty-progress-state">
      {Array.from({ length: isTablet ? 2 : 4 }).map((_, index) => (
        <Styles.Box key={index} />
      ))}
      <Styles.EmptyStateText>
        <Styles.EmptyStateIcon src={states[props.state].icon} />
        <Styles.EmptyStateTitle>{states[props.state].title}</Styles.EmptyStateTitle>
      </Styles.EmptyStateText>
    </Styles.EmptyStateContainer>
  )
}
